import { gql } from '@apollo/client';

export const DASHBOARD_REGISTRATION_OUTCOMES = gql`
  query RegistrationOutcomes($input: DashboardFilterArgs) {
    ratioBronzeRegistrationOutcome(input: $input)
    ratioGoldRegistrationOutcomes(input: $input)
    ratioSilverRegistrationOutcomes(input: $input)
  }
`;
